"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordWithConfirmationSchema = void 0;
const zod_1 = require("zod");
exports.passwordWithConfirmationSchema = zod_1.z
    .object({
    password: zod_1.z.string().min(8, { message: 'form.errors.password-min-length' }),
    confirm: zod_1.z.string(),
})
    .refine((values) => values.password === values.confirm, {
    message: 'form.errors.password-confirmation-not-match',
    path: ['confirm'],
});
